

// const ADB2C_ENDPOINT = 'https://login.microsoftonline.com/atomx.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_BOBO-POL&client_id=4c6b5f37-92ad-4efe-87f7-faf5b6912648&nonce=defaultNonce&redirect_uri=http%3A%2F%2Flocalhost%3A3000%2Flogin&scope=openid&response_type=id_token&prompt=login&response_mode=query'
// const ADB2C_ENDPOINT = `https://login.microsoftonline.com/ecartadb2c.onmicrosoft.com/oauth2/v2.0/authorize?p=${process.env.REACT_APP_ENVIRONMENT_LOGIN_AUTHORIZE}&client_id=${process.env.REACT_APP_ENVIRONMENT_LOGIN_CLIENT_ID}&nonce=defaultNonce&redirect_uri=${process.env.REACT_APP_ENVIRONMENT_LOGIN_URL}&scope=openid&response_type=id_token&prompt=login&ui_locales=en&response_mode=query`

const HOST = process.env.REACT_APP_ENVIRONMENT_API_HOST //'http://localhost:1337'// https://condo.animation-genius.com
const QR_HOST = process.env.REACT_APP_ENVIRONMENT_QR_HOST
const API = {
    ADB2C_CALLBACK: '/auth/adb2c/callback'
}
const NAME = process.env.REACT_APP_ENVIRONMENT_NAME

export { HOST, QR_HOST, API, NAME }



// WEBPACK FOOTER //
// ./src/configs/index.js